import { render, staticRenderFns } from "./Preamble.vue?vue&type=template&id=0200a271&"
import script from "./Preamble.vue?vue&type=script&lang=js&"
export * from "./Preamble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports